import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

export interface AnalyticsPayload {
  result_uuid: string;
  work_platform_id: string;
  identifier: string;
  match: string | number;
}

@Injectable({ providedIn: "root" })
export class CreatorAnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/aitools/creator-profile-analytics`;

  getAnalyticsData(payload: AnalyticsPayload): Observable<any> {
    return this.http.post<any>(`${this.base}/`, payload);
  }

  checkAnalyticsCache(
    platformId: string,
    identifier: string
  ): Observable<{ cached: boolean }> {
    const params = new HttpParams()
      .set("work_platform_id", platformId)
      .set("identifier", identifier);
    return this.http.get<{ cached: boolean }>(`${this.base}/check/`, {
      params,
    });
  }
}
